import blogger from '../../images/blogger.png';
import dribble from '../../images/dribble.png';
import evernote from '../../images/evernote.png';
import facebook from '../../images/facebook.png';
import flipboard from '../../images/flipboard.png';
import getpocket from '../../images/getpocket.png';
import github from '../../images/github.png';
import googleplus from '../../images/googleplus.png';
import instagram from '../../images/instagram.png';
import linkedIn from '../../images/linkedin.png';
import reddit from '../../images/reddit.png';
import tumblr from '../../images/tumblr.png';
import twitter from '../../images/twitter.png';

export const getSocialIconByURL = (url: string) => {
  if (url.indexOf('linkedin') > 0) {
    return linkedIn;
  }
  if (url.indexOf('facebook') > 0) {
    return facebook;
  }
  if (url.indexOf('instagram') > 0) {
    return instagram;
  }
  if (url.indexOf('github') > 0) {
    return github;
  }
  if (url.indexOf('dribble') > 0) {
    return dribble;
  }
  if (url.indexOf('twitter') > 0) {
    return twitter;
  }
  if (url.indexOf('plus.google') > 0) {
    return googleplus;
  }
  if (url.indexOf('tumblr') > 0) {
    return tumblr;
  }
  if (url.indexOf('reddit') > 0) {
    return reddit;
  }
  if (url.indexOf('evernote') > 0) {
    return evernote;
  }
  if (url.indexOf('getpocket') > 0) {
    return getpocket;
  }
  if (url.indexOf('blogger.com') > 0) {
    return blogger;
  }
  if (url.indexOf('flipBoard') > 0) {
    return flipboard;
  }
  return undefined;
};
